// @core/api/endpoints/subscription/delete_plan.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Delete subscription plan
 * Archives a subscription plan. The plan is hidden from new subscriptions but existing subscribers continue with their current terms.
 */
export async function DeletePlan(
  plan_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/plans/:plan_id`;
  requestPath = requestPath.replace(':plan_id', encodeURIComponent(plan_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
